import * as React from 'react';

const CloseIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    fill="none"
    viewBox="0 0 20 21"
  >
    <rect width="20" height="20" y="0.5" fill="#35363C" rx="4"></rect>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.333"
      d="m14 15-4-4m0 0L6 7m4 4 4-4m-4 4-4 4"
    ></path>
  </svg>
);

export default CloseIcon;
